import * as debug from 'debug';
import * as _ from 'lodash';
import {
  Component,
  ChangeDetectorRef,
  AfterViewInit,
  Input,
} from '@angular/core';
import { ModalController, ToastController } from 'ionic-angular';
import { ToolsProvider } from '../../../providers/tools/tools';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { UserProvider } from '../../../providers/user/user';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';
import { ConfigProvider } from '../../../providers/config/config';

@Component({
  selector: 'lc-chat-window',
  templateUrl: 'chat-window.html',
})
export class LCChatWindowComponent implements AfterViewInit {
  log = debug('app:ChatWindowComponent');

  @Input() room;
  @Input() typingUsers;

  constructor(
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public liveChat: LiveChatProvider,
    public toastCtrl: ToastController,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public configs: ConfigProvider
  ) {
    this.log('chat-window');
  }

  ngAfterViewInit() {}

  async ngOnInit() {
    if (!this.room) {
      this.room = _.sample(this.liveChat.localConversations);
      if (!this.room) {
        this.room = _.sample(await this.liveChat.getPublicRooms());
      }
    }
  }

  openSponsorshipUrl(room) {
    const url = _.get(room, 'sponsorship.url');
    if (url) {
      this.tools.openExternalUrl(url, 'external');
    }
  }

  private preventDefaults(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  async navToGeneralChat(event, convo) {
    this.preventDefaults(event);
    this.liveChat
      .getConversation(convo)
      .then(conversation => {
        if (conversation?.isClosed) {
          return this.toastCtrl
            .create({
              message:
                'This room is not currently open. Please try again or come back later.',
              duration: 1000,
            })
            .present();
        } else {
          // TODO navTo
          // this.tools.openExternalUrl(
          //   `/home/chat/${conversation._id}`,
          //   'deep-link'
          // );
          this.tools.navTo('ChatPage', 1, {conversation_id: conversation._id});
        }
      })
      .catch(e => {
        this.log('error getting conversation');
        const toast = this.toastCtrl.create({
          message:
            'An error occurred while retrieving this conversation. Please check your connection and try again. If the issue continues, please contact us for help.',
          position: 'top',
          duration: 5000,
        });
        toast.present();
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/chat-window/chat-window.ts